import { useForm, ValidationError } from "@formspree/react";
import { useEffect, useState } from "react"
import styled from 'styled-components';
import { isMobile } from "react-device-detect"
import { imagenesAll } from "../asset/img"
//icons
import { TiMessages } from "react-icons/ti";
import { CiMail } from "react-icons/ci";
import { FaLinkedinIn, FaInstagram, FaFacebookF, FaTiktok, FaWhatsapp  } from "react-icons/fa";
import { IoMdArrowUp } from "react-icons/io";
import { HiOutlineChevronDoubleRight } from "react-icons/hi";
import { useAllContext } from "../context/contextAll";
import { useLocation, useNavigate } from "react-router-dom";

//header nav no open
export const Header = () => {
  return(
    <>
    {isMobile ? <IsMobileHeader/> : <IsPcHeader  />}
    </>
  )
}
export const IsPcHeader = ({ imgUrlWaz }) => {
  const { isOpenNav, setIsOpenNav } = useAllContext();
  const [isMobile, setIsMobile] = useState(false);  // Estado para controlar el ancho de la ventana
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 880); // Cambié el valor a 880px
    };

    // Agregar el event listener para el cambio de tamaño de la ventana
    window.addEventListener('resize', handleResize);

    // Llamar a la función una vez para establecer el estado inicial
    handleResize();

    // Limpiar el event listener cuando el componente se desmonte
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) {
    return (
      <div className="d-none">
      </div>
    );
  }

  return (
    <header className="d-flex w-100 m_header_nav_desktop ">
      <nav className="w-100 m_text_secondary d-flex justify-content-around align-items-center py-2 mx-5 px-5">
        <img onClick={() => navigate('/')} className="m_h_60 m_pointer" src={imgUrlWaz} alt="WAZ" />
        <div className="m_bg_primary rounded-1 px-1">
          <button onClick={() => navigate('/servicios')} className="py-1 px-3 m_tm m_bg_primary m_text_secondary border-0 m_text_primaryHover ma_nav_btn_hover">Servicios</button>
          <button onClick={() => navigate('/nosotros')} className="py-1 px-3 m_tm m_bg_primary m_text_secondary border-0 m_text_primaryHover ma_nav_btn_hover">Nosotros</button>
          <button onClick={() => navigate('/faq')} className="py-1 px-3 m_tm m_bg_primary m_text_secondary border-0 m_text_primaryHover ma_nav_btn_hover">FAQ</button>
          <button onClick={() => navigate('/contacto')} className="py-1 px-3 m_tm m_bg_primary m_text_secondary border-0 m_text_primaryHover ma_nav_btn_hover">Contactos</button>
        </div>
        <div className="">
          <a style={{ textDecoration: "none", color: "inherit" }} href="mailto:info@wazexperience.com?subject=Consulta&body=Hola,%20quiero%20contactar%20con%20ustedes">
            <span className="m_bg_amarillo px-4 py-1 rounded-2 m_tm">Get in touch</span>
          </a>

        </div>
      </nav>
    </header>
  );
};
export const IsMobileHeader = () => {
  const { isOpenNav, setIsOpenNav } = useAllContext();
  return( 
    <div className="d-none"></div>
  )
}

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Lo más agresivo posible
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Si hay algún contenedor con scroll, también lo reseteamos
    const appContainer = document.querySelector('.App');
    if (appContainer) appContainer.scrollTop = 0;
  }, [pathname]);

  return null;
};

//wspp flotante
export const WppFlotante =()=> {
  return<>
    {isMobile ? <WsppFlotanteMobile /> : <WsppFlotanteDesktop/> }
    </>
}
const WsppFlotanteDesktop =()=>{
  return(
    <div className="m_wsppFlotante m_dfc">
      <a href="https://wa.link/95g0hx" target="_blank" rel="noopener noreferrer">
  <FaWhatsapp color="purple" size={30} />
</a>
    </div>
  )
}
const WsppFlotanteMobilew =()=>{
  return(
    <div className="m_wspp_flotanteMobile">
     <div className="d-flex justify-content-around align-items-center w-100 py-2">
  <a href="https://wa.link/95g0hx" target="_blank" rel="noopener noreferrer">
    <FaWhatsapp className="m_text_primary" size={25} />
  </a>
  <div className="text-white">|</div>
  <a href="mailto:info@wazexperience.com">
    <CiMail className="m_text_primary" size={25} />
  </a>
</div>

    </div>
  )
}
const WsppFlotanteMobile =()=>{
  return(
    <div className="m_wspp_flotanteMobile2 w-100">
      <div className="w-100 d-flex justify-content-end align-items-end">
      <a className="me-2 m_bg_amarillo rounded-5 p-1" href="https://wa.link/95g0hx" target="_blank" rel="noopener noreferrer">
        <FaWhatsapp className="" color="green" size={30} />
      </a>
      </div>
    </div>
  )
}
//nav open extend
export const NavExtend =()=>{
  return(
    <>
    {isMobile ? <NavExtendMobile /> : <NavExtendDesktop /> }
    </>
  )
}
const NavExtendDesktop =()=>{ 
  const [ isOpenNav, setIsOpenNav ] = useState(false);
  const navigate =useNavigate("/")
  return(
    <div className="m_bg_f2f2f2">
      <div onClick={()=>setIsOpenNav(true)}className={`m_nav_burger_flotante rounded-2 ${isOpenNav ? "d-none " : "m_bg_f2f2f2"}`}>
        <div className="m_menuBurger">
          <img className="" src={imagenesAll.navMenuBurger} alt="vectores burger" />
        </div>
      </div>
      <div onClick={()=>setIsOpenNav(false)} className={`m_nav_burger_flotante rounded-2 ${isOpenNav ? " m_bg_primary m_bg_f2f2f2" :  "d-none"}`}>
        <div className="m_menuBurger">
        <img className="" src={imagenesAll.navMenuBurgerClose} alt="vector close" />
        </div>
      </div>
      <nav className={`m_nav_extended_desktop d-flex w-100 m_h100vh m_bg_primary ${isOpenNav ? 'ma_navOpen' : 'ma_navOpenClose'}`}>
        <div className="m_bg_secondary m_w_30 text-center">
          <img  onClick={()=>{
                  setIsOpenNav(false)
                  navigate('/')
                  }} className="mt-5 me-2 m_pointer"  src={imagenesAll.logoWazBlanco} alt="WAZ" />
        </div>

        <div className="m_w_70  d-flex flex-column m_text_secondary align-items-center">
          <div className="m_w_90 d-flex justify-content-between my-2 mt-3">
            <h5 className="m_bs ms-2 m_">NAVEGACIÓN</h5>
            <div className="me-5">
              <span className="m_bg_amarillo px-5 py-1 rounded-2 me-3 ">Get in touch</span>
            </div>
          </div>
          <div className="d-flex m_text_secondary w-100 h-100 justify-content-around">
            <div className="h-100 d-flex flex-column justify-content-center">
                <button onClick={()=>{
                  setIsOpenNav(false)
                  navigate('servicios')
                  }} className="my-3 m_h2 border-0 m_bg_primary m_text_secondary py-1 px-3 m_nav_extend_btn_hover m_hm m_btn_nav_extend text-start">Servicios</button>
                {/* <button onClick={()=>{
                  setIsOpenNav(false)
                  navigate('proyectos')
                  }} className="border-0 m_bg_primary m_text_secondary py-1 px-3 m_nav_extend_btn_hover m_hm m_btn_nav_extend text-start">Proyectos</button> */}
                <button onClick={()=>{
                  setIsOpenNav(false)
                  navigate('nosotros')
                  }} className="my-3 m_h2 border-0 m_bg_primary m_text_secondary py-1 px-3 m_nav_extend_btn_hover m_hm m_btn_nav_extend text-start">Nosotros</button>
                <button onClick={()=>{
                  setIsOpenNav(false)
                  navigate('faq')
                  }} className="my-3 m_h2 border-0 m_bg_primary m_text_secondary py-1 px-3 m_nav_extend_btn_hover m_hm m_btn_nav_extend text-start">FAQ</button>
                <button onClick={()=>{
                  setIsOpenNav(false)
                  navigate('contacto')
                  }} className="my-3 m_h2 border-0 m_bg_primary m_text_secondary py-1 px-3 m_nav_extend_btn_hover m_hm m_btn_nav_extend text-start">Contacto</button>
            </div>
            <div className="d-flex flex-column text-start justify-content-end me-5 pe-5 mb-4">
              <span className="m_bs my-1">GET IN TOUCH</span>
              <span className="m_bl  fs-5">wazexperience@gmail.com</span>
              <span className="m_bl  fs-5">+549 351 688 4711</span>
            </div>
            <div className="d-flex flex-column justify-content-end ms-5 mb-2 me-5">
            <a className="m_text_secondary" href="https://www.facebook.com/experience.waz?rdid=35acDFO2p6B4vp0T&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14eQnf6dT7%2F#" target="_blank" rel="noopener noreferrer">
                  <FaFacebookF  className="my-2 m_pointer" size={30}/>
                </a>
                <a className="m_text_secondary" href="https://www.linkedin.com/company/waz-experience/" target="_blank" rel="noopener noreferrer">
                  <FaLinkedinIn className="my-2 m_pointer" size={30}/>
                </a>
                <a className="m_text_secondary" href="https://www.instagram.com/waz.experience/" target="_blank" rel="noopener noreferrer">
                  <FaInstagram  className="my-2 m_pointer" size={30}/>
                </a>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}

const NavExtendMobile =()=>{
  const [ isOpenNav, setIsOpenNav ] = useState(false);
  const navigate = useNavigate('/')
  return(
    <div className="m_nav_header_mobile  w-100">
      <div className="m_header_nav_mobile_part1 m_bg_f2f2f2 d-flex justify-content-around align-items-center py-2 w-100">
        <a href="mailto:info@wazexperience.com" className="m_bg_secondary m_text_primary px-3 py-1 rounded-2 fs-5 text-decoration-none">
         Get in touch
        </a>
        <img onClick={() => navigate('/')} className="m_w_20" src={imagenesAll.logoWazBordo} alt="logo waz vectores" />
        <div onClick={()=>setIsOpenNav(true)}className={`m_nav_burger_flotanteMobile ${isOpenNav ? "d-none" : "m_bg_primary"}`}>
          <div className="m_menuBurger">
            <img className="" src={imagenesAll.navMenuBurger} alt="vectores burger" />
          </div>
        </div>
        <div onClick={()=>setIsOpenNav(false)} className={`m_nav_burger_flotanteMobile ${isOpenNav ? "m_bg_f2f2f2" :  "d-none"}`}>
          <div className="m_menuBurger">
            <img className="" src={imagenesAll.navMenuBurgerClose} alt="vector close" />
          </div>
        </div>
      </div>
      <div className={`m_header_nav_mobile_part2 m_bg_f2f2f2 m_h100vh w-100 d-flex flex-column justify-content-around ${isOpenNav ? "m_nav_extend_open" : "m_nav_extend_close d-none" }} `}>
        <EmpityBox />
        <div className="ms-3">
          <div onClick={()=>{
            setIsOpenNav(false)
            navigate('/')}} className="m_text_secondary my-3">
            <HiOutlineChevronDoubleRight />
            <span className="ms-2 fs-2">Inicio</span>
          </div>
          <div onClick={()=>{
            setIsOpenNav(false)
            navigate('/servicios')}} className="m_text_secondary my-3">
            <HiOutlineChevronDoubleRight />
            <span className="ms-2 fs-2">Servicios</span>
          </div>
          {/* <div  onClick={()=>{
            setIsOpenNav(false)
            navigate('/proyectos')}} className="m_text_secondary my-3"> 
            <HiOutlineChevronDoubleRight />
            <span className="ms-2 fs-2">Proyectos</span>
          </div> */}
          <div  onClick={()=>{
            setIsOpenNav(false)
            navigate('/nosotros')}} className="m_text_secondary my-3"> 
            <HiOutlineChevronDoubleRight />
            <span className="ms-2 fs-2">Nosotros</span>
          </div>
          <div  onClick={()=>{
            setIsOpenNav(false)
            navigate('/faq')}} className="m_text_secondary my-3"> 
            <HiOutlineChevronDoubleRight />
            <span className="ms-2 fs-2">FAQ</span>
          </div>
          <div  onClick={()=>{
            setIsOpenNav(false)
            navigate('/contacto')}} className="m_text_secondary my-3"> 
            <HiOutlineChevronDoubleRight />
            <span className="ms-2 fs-2">Contacto</span>
          </div>
        </div>
        {/*Contactos */}
        <div className="d-flex flex-column text-end pe-4 m_text_secondary">
          <span className="m_bl fs-4">wazexperience@gmail.com</span>
          <span className="m_bl fs-4">+549 351 688 4711</span>
        </div>
         {/* Redes */}
        <div className="w-100 mb-5">
          <FaFacebookF className="m_text_secondary mx-3" size={30}/>
          <FaLinkedinIn className="m_text_secondary mx-3" size={30}/>
          <FaInstagram   className="m_text_secondary mx-3" size={30}/>
        </div>
      </div>
    </div>
    
  )
}


//casi footer
export const BeforeFooterDekstop =({text1, text2, text3, textBtn})=>{
  const navigate = useNavigate("")
  return(
    <div className="m_h100vh w-100 m_bg_secondary d-flex align-items-center justify-content-center ma_beforeFooterDekstop_img m_text_white">
      <img className="d-none" src={imagenesAll.vBeforeFooter} alt="vector-coral" />
        <div className="m_w_70 align-items-center">
        <div className="m_text_white ms-5">
          <p className="m_h1 m_text_white">{text1} <br></br>{text2} <br></br>{text3}</p>
          <button onClick={()=> navigate("/contacto")} className="border-0 rounded-2 py-2 px-3 m_bg_orange m_text_white m_bs fs-4"> {textBtn}</button>
        </div>
      </div>
      </div>
  )
}
export const BeforeFooterMobile =({text1, text2, text3, textBtn})=>{
  const navigate = useNavigate("")
  return(
    <div className="py-5 w-100 m_bg_secondary d-flex align-items-center justify-content-center ma_beforeFooterDekstop_imgMobile">
        <div className="m_w_90 align-items-center ">
        <div className="m_text_white">
          <p className="m_hl m_text_white">{text1} <br></br>{text2} <br></br>{text3}</p>
          <button onClick={()=> navigate("/contacto")} className="border-0 rounded-2 py-2 px-3 m_bg_orange m_text_white m_bl"> {textBtn}</button>
        </div>
      </div>
      </div>
  )
}



// footer 
export const Footer =()=>{
  return(
    <>
      {isMobile ? <FooterMobile /> : <FooterDesktop /> }
    </>
  )
}



const FooterDesktop = () => {
  const [email, setEmail] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [state, handleSubmitFormspree] = useForm("mqaljogj"); // tu ID de Formspree

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSubmitFormspree(e);
  };

  useEffect(() => {
    if (state.succeeded) {
      setEmail(""); // limpia el input
      setShowPopup(true); // muestra el popup
    }
  }, [state.succeeded]);

  return (
    <>
      <footer className="m_bg_primary m_text_secondary py-5">
        <div className="container pt-5">
          <div className="row">
            {/* Columna izquierda */}
            <div className="col-lg-6">
              <div className="d-flex flex-column">
                <span className="m_font_primary m_bs text-start">
                  ULTIMAS NOVEDADES
                </span>
                <p className="m_hl m_h1 text-start">
                  Get our <br /> newsletter
                </p>

                <form onSubmit={handleSubmit} className="d-flex">
                  <input
                    className="m_text_secondary m_input_footer"
                    type="email"
                    name="email"
                    placeholder="Your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button
                    className="m_bl m_bg_amarillo border-0 rounded-2 ms-3 px-2"
                    type="submit"
                    disabled={state.submitting}
                  >
                    Presupuesto
                  </button>
                </form>

                <ValidationError
                  prefix="Email"
                  field="email"
                  errors={state.errors}
                />
              </div>
            </div>

            {/* Columna derecha */}
            <div className="col-lg-6 d-flex justify-content-end">
              <div className="d-flex flex-column text-start justify-content-end me-5 pe-5">
                <span className="m_bs my-1">GET IN TOUCH</span>
                <span className="m_bm my-1">info@wazexperience.com</span>
                <span className="m_bl my-1">+54 9 351 370-8624</span>
              </div>
              <div className="d-flex flex-column justify-content-end">
                <a
                  className="m_text_secondary"
                  href="https://www.instagram.com/waz.experience/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram className="my-2 m_pointer" size={30} />
                </a>

                <a
                  className="m_text_secondary"
                  href="https://www.facebook.com/experience.waz"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF className="my-2 m_pointer" size={30} />
                </a>

                <a
                  className="m_text_secondary"
                  href="https://www.tiktok.com/@waz.experience"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTiktok className="my-2 m_pointer" size={30} />
                </a>

                <a
                  className="m_text_secondary"
                  href="https://www.linkedin.com/company/waz-experience/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn className="my-2 m_pointer" size={30} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Línea inferior */}
        <div className="container mb-4">
          <div className="row">
            <div className="col-12 m_footer_line mt-5 ms-2"></div>
          </div>
          <div className="row mt-4">
            <div className="col-lg-8">
              <button className="m_bs border-0 m_bg_primary mx-2">
                AVISO LEGAL
              </button>
              <button className="m_bs border-0 m_bg_primary mx-2">
                POLÍTICA COOKIES
              </button>
              <button className="m_bs border-0 m_bg_primary mx-2">
                POLÍTICA DE PRIVACIDAD
              </button>
              <button className="m_bs border-0 m_bg_primary mx-2">
                TÉRMINOS DE SERVICIO
              </button>
            </div>
            <div className="col-lg-4 d-flex justify-content-center">
             <button
                className="m_text_secondary m_bg_pink border-0 rounded-2 d-flex p-1 px-2 ms-5 d-none"
                onClick={() =>
                  window.scrollTo({ top: 0, behavior: "smooth" })
                }
              >
              Subir <IoMdArrowUp size={21} />
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* POPUP de confirmación */}
      {showPopup && (
        <div
          className="popup-overlay "
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="popup-content m_bg_primary text-black p-4 rounded-3 text-center ma_contacto_send"
            style={{ maxWidth: "500px" }}
          >
            <p className="fs-4 fw-bold">
              ¡Gracias por ponerte en contacto con nosotros!
            </p>
            <span>
              <TiMessages color="#f56763" size={40} />
            </span>
            <p className="m_p_lm">
              Nos alegra saber que estás interesado en nuestros servicios.
            </p>
            <p className="m_p_lm">
              Uno de nuestros representantes se pondrá en contacto lo antes
              posible para conversar más detalles sobre tu consulta.
            </p>
            <button
              onClick={() => setShowPopup(false)}
              className="m_bg_amarillo border-0 rounded-2 mt-3 px-4 py-2"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </>
  );
};


const FooterMobile = () => {
  const [email, setEmail] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [state, handleSubmitFormspree] = useForm("mqaljogj"); // ID de Formspree

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSubmitFormspree(e);
  };

  useEffect(() => {
    if (state.succeeded) {
      setEmail("");
      setShowPopup(true);
    }
  }, [state.succeeded]);

  return (
    <>
      <footer className="m_bg_primary d-flex flex-column">
        {/* Logo y redes */}
        <div className="my-5 m_text_primary text-center d-flex flex-column justify-content-center align-items-center">
          <img className="w-25 my-3" src={imagenesAll.logoWBordoOscuro} alt="Logo WAZ" />
          <span className="m_bg_secondary rounded-2 px-3 m_hs">Get in touch</span>
          <div className="d-flex mt-5 w-50 justify-content-between">
            <a className="m_text_secondary" href="https://www.instagram.com/waz.experience/" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="my-2 m_pointer" size={30} />
            </a>
            <a className="m_text_secondary" href="https://www.facebook.com/experience.waz" target="_blank" rel="noopener noreferrer">
              <FaFacebookF className="my-2 m_pointer" size={30} />
            </a>
            <a className="m_text_secondary" href="https://www.tiktok.com/@waz.experience" target="_blank" rel="noopener noreferrer">
              <FaTiktok className="my-2 m_pointer" size={30} />
            </a>
            <a className="m_text_secondary" href="https://www.linkedin.com/company/waz-experience/" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn className="my-2 m_pointer" size={30} />
            </a>
          </div>
        </div>

        {/* Newsletter */}
        <div className="m_text_secondary text-start ms-3">
          <p className="m_hl">Get our <br /> newsletter</p>
          <form onSubmit={handleSubmit} className="d-flex w-100">
            <input
              className="m_text_secondary m_input_footer"
              type="email"
              name="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button
              className="m_bl m_bg_amarillo border-0 rounded-2 ms-3"
              type="submit"
              disabled={state.submitting}
            >
              Presupuesto
            </button>
          </form>

          <ValidationError prefix="Email" field="email" errors={state.errors} />
        </div>

        {/* Contacto */}
        <div className="m_text_secondary d-flex flex-column text-end my-5 me-3">
          <span className="m_bl my-1">info@wazexperience.com</span>
          <span className="m_bs my-1">+54 9 351 370-8624</span>
        </div>

        {/* Enlaces legales */}
        <div className="text-center mb-3">
          <button className="m_bs border-0 m_bg_primary">Aviso legal</button>
          <span>|</span>
          <button className="m_bs border-0 m_bg_primary">Política de cookies</button>
          <span>|</span>
          <button className="m_bs border-0 m_bg_primary">Política de privacidad</button>
          <span>|</span>
          <button className="m_bs border-0 m_bg_primary">Términos y condiciones</button>
          <br />
          <span className="m_bs">© {new Date().getFullYear()} WAZ</span>
        </div>
      </footer>

      {/* POPUP de confirmación */}
      {showPopup && (
        <div
          className="popup-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="popup-content m_bg_primary text-black p-4 rounded-3 text-center ma_nosotros_cortina_ceoMobile"
            style={{ maxWidth: "500px"}}
          >
            <p className="fs-4 fw-bold">¡Gracias por ponerte en contacto con nosotros!</p>
            <span>
              <TiMessages color="#f56763" size={40} />
            </span>
            <p className="m_p_lm">Nos alegra saber que estás interesado en nuestros servicios.</p>
            <p className="m_p_lm">
              Uno de nuestros representantes se pondrá en contacto lo antes posible para conversar más detalles sobre tu consulta.
            </p>
            <button
              onClick={() => setShowPopup(false)}
              className="m_bg_amarillo border-0 rounded-2 mt-3 px-4 py-2"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </>
  );
};



export const EmpityBox=()=>{
  return(
    <div className="m_empity_box"></div>
  )
}

export const PieDePaginaRedes =()=>{

}
